import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
    namespaced: true,
    state: {
        apiKey: '',
        searchParam: 'smSearch', // название гет-параметра для включения поиска
        headerSelector: '.header',
        baseUrl: '/search/search',
        visible: false,
        mode: 'start', // start || category
        q: '', // search string
        selected_category: 0,
        selected_category_name: '',
        selected_param: '', // текущий установленный параметр (Напряжение, Разъем ...)
        isMobile: false,
        showSortMobile: false,
        isIE: false,
        hiddenByScroll: false,
        isOpenFacets: false,
        currentOpenFacet: '', // для управление показом выбора категории в моб.версии
        // category не входит в queryFilter
        // [{brand: Traxxas;Polymotors},{Влагозащита: "Есть"}, {MaxPrice: 5000}, {Цвет: #4682B4;#8B0000}]
        queryFilters:[],
        products: [], // results of search
        autocomplete: {
            sts: [], // часто ищут
            correction: [], // коррекция поисковой фразы
            categories: [], // категории в выборке [{id:352, name: 'Аккумуляторы', value:17}]
        },
        history: [], // история поиска пользователя
        facets: { // все фасеты выбранной категории
            availability: [], // [{id:'в наличии', name:'в наличии', value:2}]
            brands: [],       // [{id:'327', name:'Traxxas Battery', value:11},{id:'116', name:'Black Magic', value:5}]
            categories: [],   // [{id:352, name: 'Аккумуляторы', value:17}]
            colors: [],       // []
            hit: [],          // []
            novelty: [],      // []
            prices: [],       // [{id:'min', name:3190, value:3190},{id:'max', name:17190, value:17190}]
            selected:[],      // [{name: 'categories', value:['Аккумуляторы]}, {name: 'brands', value:['Black Magic', 'Zee Power']}, {name: 'Напряжение', value:['11.1в']}]
            tags: [],         // [
                              //   {name:'Назначение', values:[{id:'Для катеров',name:'Для категов',value:2}, {id:'Для машин',name:'Для машин',value:2}]},
                              //   {name:'Напряжение', values:[{id:'11.1в',name:'11.1в',value:3},{id:'14.8в',name:'14.8в',value:1},{id:'7.4в',name:'7.4в',value:1}]},
                              //   {name:'Тип аккумулятора', values:[{id:'LiPo',name:'LiPo',value:5}]}
                              //  ]

        },
        facets_actual: { // фасеты из выборки товаров
            availability: [], // [{id:'в наличии', name:'в наличии', value:1}]
            brands: [],       // [{id:'327', name:'Traxxas Battery', value:11},{id:'116', name:'Black Magic', value:5}]
            categories: [],   // [{id:352, name: 'Аккумуляторы', value:17}]
            colors: [],
            hit: [],
            novelty: [],
            prices: [],       // [{id:'min', name:7990, value:7990},{id:'max', name:9626, value:9626}]
            tags: [],         // [
                              //   {name:'Назначение', values:[{id:'Для катеров',name:'Для категов',value:2}, {id:'Для машин',name:'Для машин',value:2}]},
                              //   {name:'Напряжение', values:[{id:'11.1в',name:'11.1в',value:3}]}]}
                              // ]
        },
        sort: 'default', // default, price_asc, price_desc
        currentPage: 0,
        pageSize: 20,
        isWasSearch: false, // флаг, был поисковый запрос
        totalHits: 0,
        doSearchAddMode: false, // добавлять или заменять результаты поиска
        priceRange:{min:0, max:0}, // диапазон цен полный
        priceSelected: [], // выбранный диапазон цен
        tips: [],
        redirectUrl: "",
        isCategoryFilter: false // включение фильтра по товарам категории
    },
    actions,
    getters,
    mutations,
};